/**
 * AuthContext - Better Auth authentication context.
 * 
 * Uses Better Auth client for session management via Convex HTTP endpoints.
 * Provides backward-compatible interface for existing components.
 */
import { createContext, useContext, useState, type ReactNode } from 'react';
import { useConvexAuth } from 'convex/react';
import { authClient } from '../lib/auth-client';

interface AuthContextType {
  isLoading: boolean;
  isSignedOut: boolean;
  setIsSignedOut: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthenticated: boolean;
  signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const [isSignedOut, setIsSignedOut] = useState(false);


  const signOut = async () => {
    await authClient.signOut();
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ isLoading, isAuthenticated, signOut, isSignedOut, setIsSignedOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
